import React from 'react';
import { Box } from '@mui/material';
import DuengePlan from '../../components/DuengePlan';

export default function GrowPlanPage() {
  return (
    <Box
      sx={{
        animation: 'fadeSlideUpCard 0.5s cubic-bezier(0.22,1,0.36,1) both',
        // Override inner component styling to match v3 dark theme
        '& .MuiCard-root, & .MuiPaper-root': {
          background: 'rgba(15,28,15,0.75) !important',
          border: '1px solid rgba(118,196,66,0.12) !important',
          backdropFilter: 'blur(16px)',
          borderRadius: '14px !important',
        },
        '& .MuiTab-root.Mui-selected': { color: '#76c442 !important' },
        '& .MuiTabs-indicator': { backgroundColor: '#76c442 !important' },
        '& .MuiButton-containedPrimary': {
          background: 'linear-gradient(135deg,#76c442 0%,#559e2e 100%) !important',
        },
        '& .MuiChip-colorPrimary': {
          borderColor: '#76c442 !important',
          color: '#76c442 !important',
        },
      }}
    >
      <DuengePlan />
      <style>{`
        @keyframes fadeSlideUpCard {
          from { opacity:0; transform:translateY(20px); }
          to   { opacity:1; transform:translateY(0);    }
        }
      `}</style>
    </Box>
  );
}
